import { createRef, useContext, useEffect, useRef, useState } from 'react';
import { Authorization } from '../../providers/AuthContextProvider';
import Timer from '../Timer';
import { AxiosPublic } from '../../config/axios';
import { CartContext } from '../../providers/CartContextProvider';
import axios from 'axios';
import Titel from '../DetailPaint/titel';
import { useNavigate } from 'react-router-dom';

const Verify = (props) => {
    const push = useNavigate()
    const user = props.user
    const Error = useRef()
    const inputRefs = Array.from({ length: 5 }, () => createRef(null));
    const { getTokens } = useContext(Authorization)
    const { state, dispatch } = useContext(CartContext)

    const [response, setResponse] = useState({ expires_in: 0 })
    const [loading, setLoading] = useState(true)
    const [sendAgain, setSendAgain] = useState()
    const [KEYBOARDS] = useState({
        backspace: 8,
        arrowLeft: 37,
        arrowRight: 39,
    });

    useEffect(() => {
        if (!user) push(-1)
        else {
            const send_otp = async () => {
                await AxiosPublic.post('/send-otp', { user })
                    .then(res => {
                        alert(res.data.message || 'ارسال شد')
                        setResponse({ expires_in: Number(res.data.data.remain) })
                    })
                    .catch(err => {
                        setResponse({ expires_in: 0 })
                        alert(err.response?.data.message || 'ارسال نشد')
                    })
                    .finally(() => setLoading(false))
            }
            send_otp()
        }
    }, [sendAgain])


    const handleInput = (e, index) => {
        const { value } = e.target
        if (value.length > 1) {
            inputRefs[index].current.value = value[0]
        }
        const nextInput = inputRefs[index + 1];
        if (nextInput && value) {
            nextInput.current.focus();
            if (nextInput.current.value) {
                nextInput.current.select();
            }
        }
        if (props.setOtp) props.setOtp(inputRefs.map(input => input.current.value).join(''))
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text');
        inputRefs.forEach((inputRef, i) => {
            inputRef.current.value = paste[i] || '';
        });
        if (props.setOtp) props.setOtp(inputRefs.map(input => input.current.value).join(''))
    };

    const handleBackspace = (e, index) => {
        if (!!e.target.value) {
            e.target.value = '';
            if (props.setOtp) props.setOtp(inputRefs.map(input => input.current.value).join(''))
            return;
        } else {
            handleArrowLeft(index)
            if (props.setOtp) props.setOtp(inputRefs.map(input => input.current.value).join(''))
        }
    };

    const handleArrowLeft = (index) => {
        const previousInput = inputRefs[index - 1];
        if (previousInput)
            previousInput.current.focus();
    };

    const handleArrowRight = (index) => {
        const nextInput = inputRefs[index + 1];
        if (nextInput)
            nextInput.current.focus();
    };

    const handleKeyDown = (e, index) => {
        switch (e.keyCode) {
            case KEYBOARDS.backspace:
                handleBackspace(e, index);
                break;
            case KEYBOARDS.arrowLeft:
                handleArrowLeft(index);
                break;
            case KEYBOARDS.arrowRight:
                handleArrowRight(index);
                break;
            default:
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault()
        const value = inputRefs.map(input => input.current.value).join('')
        if (value.length < 5) {
            Error.current.innerText = 'طول کد 5 واحد است.'
        } else {
            Error.current.innerText = ''
            const data = {
                user,
                otp: value,
            }
            await AxiosPublic.post(`${props.exists === 1 && 'login' || props.exists === 2 && 'register/store'} `, data)
                .then(async ({ data }) => {
                    const { token, ...prev } = data.data
                    getTokens(token)
                    await axios.post('shopping-cart/store', state,
                        { headers: { Authorization: `${token.token_type} ${token.access_token} ` } })
                        .then(res => dispatch({ type: "UPDATE_CART", payload: res.data.data }))
                        .catch(err => alert(err.response?.data.message))
                    await push(`/${prev.is_admin ? 'admin' : 'profile'}/information`)
                })
                .catch(err => alert(err.response?.data.message))
        }
    }


    return (
        <>
            <main className='centerOfParent my-20' dir='rtl'>
                <section className='max-w-[400px] w-full p-6 border border-gray-300 bg-white rounded-lg'>
                    <div className='flex flex-col'>
                        <Titel className='mb-4 text-lg' title='رمز یکبار مصرف' />
                        <div className='text-purple-900 mb-2 break-words'>
                            رمز یکبار مصرف ارسال شده به {user} را وارد کنید.
                        </div>
                        {(!props.justOtp) && <p className='text-sm mb-3 cursor-pointer text-blue-500' onClick={() => props.setVerifyCom(0)}>ویرایش</p>}
                        <form className='relative flex flex-col gap-2.5'>
                            <div className='flex items-center justify-between' dir='ltr'>
                                {inputRefs.map((inputRef, index) => (
                                    <input
                                        key={index}
                                        ref={inputRef}
                                        type="number"
                                        max={9}
                                        min={0}
                                        maxLength="1"
                                        pattern="[0-9]"
                                        className='block text-center text-xl w-[calc(calc(100%/6)-8px)] h-12 leading-6
                                         text-[#C3003F] border rounded-lg duration-150 focus:border-[#C3003F] focus:outline-none'
                                        onInput={(e) => handleInput(e, index)}
                                        onKeyDown={e => handleKeyDown(e, index)}
                                        onPaste={index === 0 ? e => handlePaste(e) : e => e.preventDefault()}
                                    />
                                ))}
                            </div>
                            <span className='absolute top-[4.5rem] right-1 text-red-600 text-xs my-2.5' ref={Error}></span>
                            {!loading ? <div className='flex items-center gap-2.5'>
                                <span>رمز را دريافت نکرده‌ايد؟ </span>
                                <Timer time={response.expires_in} withHour={false}
                                    message={<p className='cursor-pointer text-blue-600' onClick={e => {
                                        setLoading(true)
                                        setSendAgain(Math.random())
                                    }}>ارسال مجدد</p>} />
                            </div> :
                                <div className="absolute bg-white bg-opacity-60 z-50 h-full w-full flex items-center justify-center">
                                    <div className="flex items-center">
                                        <span className="text-3xl mr-4">Loading</span>
                                        <svg className='animate-spin h-8 w-8 text-gray-800' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                                    </div>
                                </div>}
                            {(!props.justOtp) && <>
                                <button onClick={handleSubmit} disabled={loading} className={`text-white h-12 w-full border-0 bg-gradient-to-r from-[#C3003F] to-[#5D001E] hover:bg-gradient-to-br  outline-none focus:outline-none font-medium rounded-lg text-lg px-5 p-2.5 text-center`}>ورود</button>
                                {props.exists === 1 && <p onClick={() => props.setVerifyCom(3)} className='text-blue-500 cursor-pointer'>ورود با رمز عبور </p>}
                            </>}
                        </form>
                    </div>
                </section>
            </main >
        </>
    );
};

export default Verify;

